import { useMemo } from 'react';

import { useGetUserTrainings } from 'lib/hooks/queries/trainings/useGetTrainings';

import AgTablePage from '../../../../AgTablePage/AgTablePage';
import { getTrainingsColumns } from '../lib/helpers';

const TrainingsTable = ({ practiceId, onEditTraining, isAdmin, timezone }) => {
  const columns = useMemo(
    () => getTrainingsColumns(onEditTraining, isAdmin, timezone),
    [onEditTraining, isAdmin, timezone]
  );

  return (
    <div className="mb-4 flex flex-1 flex-col">
      <AgTablePage
        title="Training"
        useData={useGetUserTrainings}
        defaultFilters={[]}
        defaultColumns={columns}
        name="meetings"
        queryParams={{ practiceId: Number(practiceId) }}
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200"
        noHeader
        autoHeight
      />
    </div>
  );
};

export default TrainingsTable;
